import 'es6-promise/auto'
import Vue from 'vue'
import swal from 'sweetalert';

new Vue({
  el: '#scope-signupform',
  data: function () {
    return {
      isDownload: false,
      popTitle: '',
      popContents: '',
      popShow: false,
      isUserPolicy: false,
      isUserPolicy1: false,
      isUserPolicy2: false,
      isUserPolicy3: false,
      isUserPolicy11: true,
      isUserPolicy12: false,
      isUserPolicy13: false,
      isCenterPolicy: false,
      isCenterPolicy1: false,
      isCenterPolicy2: false,
      p0: false,
      p1: false,
      p2: false,
      p3: false,
      p4: false,
      p5: false,
      p5_1: false,
      p5_2: false,

      isYouthPolicy: false,
      isYouthPolicy1: false,

      searchModel: {
        pageUrl: 'youth'
        , isAgree: true
      }
    }
  },
  mounted: function () {
    if($('#ptype').val() != '' && $('#ptype').val() == 'isUserPolicy12') {
      this.isUserPolicy12 = true;
      this.isUserPolicy11 = false;
      this.isUserPolicy13 = false;
    }

  },
  methods: {
    fnOnLoadInit: function () {

    }
    , fnOnLoadList: function () {

    }
    , fnOnClickAgreeTarget: function (evt) {
      this.searchModel.isAgree = evt.target.checked;
    },
    fp0: function () {
      this.p1 = !this.p0
      this.p2 = !this.p0
      this.p3 = !this.p0
      this.p0 = !this.p0
    },
    fp1: function () {
      this.p1 = !this.p1;
      this.p0 = this.p1 && this.p2 && this.p3
    },
    fp2: function () {
      this.p2 = !this.p2;
      this.p0 = this.p1 && this.p2 && this.p3
    },
    fp3: function () {
      this.p3 = !this.p3;
      this.p0 = this.p1 && this.p2 && this.p3
    },
    fp4: function () {
      this.p4 = !this.p4;
    }
    ,fp5: function (num) {
      if(num == 2) {
        this.p5_2 = true;
        this.p5_1 = false;
      } else if(num == 1) {
        this.p5_1 = true;
        this.p5_2 = false;
      }

    }
    , fnOnClickSignUpCategory: function (value) {
      if (this.searchModel.pageUrl != 'btype') this.isDownload = false;
      this.searchModel.pageUrl = value;

      if (value == 'signprev') {
        this.isUserPolicy11 = false;
        this.isUserPolicy12 = true;
        this.isUserPolicy13 = false;
      } else if (value == 'youth') {
        this.isUserPolicy11 = true;
        this.isUserPolicy12 = false;
        this.isUserPolicy13 = false;
      } else {
        this.isUserPolicy11 = false;
        this.isUserPolicy12 = false;
        this.isUserPolicy13 = true;
      }
      this.p0 = false;
      this.p1 = false;
      this.p2 = false;
      this.p3 = false;
      this.p4 = false;
      this.p5 = false;
      this.p5_1 = false;
      this.p5_2 = false;

    }
    , fnOnClickNextPage: function () {

      if (this.searchModel.pageUrl == 'youth' && this.p4) {
        this.searchModel.pageUrl = "underYouth";
      }
      if (this.searchModel.isAgree && this.p0) {
        if (this.searchModel.pageUrl.indexOf('fe') > -1) {
          let eCase = 'adult';
          if(this.p5_1 || this.p5_2) {
            eCase = 'youth';
          }
          location.href = '/youthnavi/signup/link_foreigner_join?encCase='+eCase;
        } else if (this.searchModel.pageUrl.indexOf('signprev') > -1) {
          location.href = '/youthnavi/signup/signprev';
        } else {

          location.href = '/youthnavi/signup/cert?encCase=' + this.searchModel.pageUrl;

        }
        // location.href = '/youthnavi/signup/' + this.searchModel.pageUrl;
      } else {
        alert("약관에 동의해주세요");
        return false;
      }

    }
    , fnOnClickNextDocument: function () {
      this.isDownload = true;
    }
    , fnOnClickNextCenter: function () {
      if (this.searchModel.pageUrl == 'ctype') {
        swal("협의중입니다.");
        return;
      } else if (this.searchModel.pageUrl == 'adult') {
        swal("기관유형을 선택헤주세요.");
        return;
      } else {
        location.href = '/youthnavi/signup/' + this.searchModel.pageUrl;
      }
    },
    fnOP: function (a) {
      if (a== '#t1') {
        this.popTitle = '서비스 이용약관';
      } else if (a== '#t2') {
        this.popTitle = '개인정보 수정 및 활용';
      } else if (a== '#t3') {
        this.popTitle = '개인정보 3자 제공';
      }
      this.popContents = document.querySelector(a).innerHTML;
      this.popShow = true;
      //var win = window.open("", "Title", "toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=780,height=200,top=" + (screen.height - 400) + ",left=" + (screen.width - 840));
      //win.document.body.innerHTML = document.querySelector(a).innerHTML;
    }
  }
});
